import { formatFileSize } from '@consigli/utils';
import { HiX } from 'react-icons/hi';

interface FileCardProps {
  file: File;
  removeFile: (index: number) => void;
  index: number;
}

export const FileCard = ({ file, removeFile, index }: FileCardProps) => {
  return (
    <div className="p-4 bg-white rounded-md border duration-200">
      <div className="flex items-start justify-between">
        <p className="text-sm font-medium"> {file.name}</p>
        <button
          className="hover:text-red-500 hover:bg-red-100 rounded-sm p-1 duration-100"
          onClick={() => removeFile(index)}
        >
          <HiX className="h-3 w-3" />
        </button>
      </div>
      <p className="text-xs text-gray-500">{formatFileSize(file.size)}</p>
    </div>
  );
};
